<div *ngIf="text" class="ion-text-justify" [ngClass]="{'chat': limit === 250, 'chat-prop': type === 'propietario' && limit === 250 }">
  <ng-container *ngIf="text.length <= limit">
    <span [innerHTML]="text"></span>
  </ng-container>

  <ng-container *ngIf="truncating && text.length > limit">
    <span *ngIf="limit === 250" [innerHTML]="truncatedTextWhenLimit"></span>
    <ion-text (click)="expand()" color="primary">
      <span *ngIf="limit === 250"> {{ 'truncated-text.Leer más'  | translate }}</span>
    </ion-text>

    <span *ngIf="limit < 250">
      {{ text | truncate : limit }}
    </span>

  </ng-container>

  <ng-container *ngIf="!truncating && text.length > limit">
    <span [innerHTML]="text"></span>
    <ion-text (click)="expand()" color="primary">
      <span *ngIf="limit === 250"> {{ 'truncated-text.Leer menos'  | translate }}</span>
    </ion-text>
  </ng-container>
</div>